import RegionalLayout from "./RegionalLayout";
import { Rocket } from "lucide-react";

const crd = {
  background: "var(--surface-card)",
  border: "var(--border-width, 1px) solid var(--border-default)",
  borderRadius: "1rem",
  boxShadow: "var(--shadow-card)",
};
const tp = { color: "var(--text-primary)" };
const ts = { color: "var(--text-secondary)" };

export default function DevelopmentReadiness() {
  return (
    <RegionalLayout>
      <div className="max-w-[1440px] mx-auto space-y-5">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight" style={tp}>Development Readiness</h1>
          <p className="text-sm mt-0.5" style={ts}>Growth interests, certification pipeline, and training demand</p>
        </div>
        <div className="p-12 flex flex-col items-center text-center" style={crd} data-testid="readiness-coming-soon">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: "rgba(34,197,94,0.08)" }}>
            <Rocket className="w-8 h-8" style={{ color: "#22c55e" }} />
          </div>
          <p className="text-lg font-semibold" style={tp}>Coming Soon</p>
          <p className="text-sm mt-2 max-w-md" style={ts}>
            Employee growth area interests, skills most flagged for development,
            certification pipeline status, and training demand signals.
          </p>
        </div>
      </div>
    </RegionalLayout>
  );
}
